<div class="logoBox">
  <a href="https://www.home365.co" target="_blank">
    <img class="logo" src="{{ './assets/img/' + (mini ? 'home365_logo_small' : darkmode ? 'home365_logo_w' : 'Home365_logo')+ '.svg' }}" alt="home 365 logo" [ngClass]="{'miniIcon': mini}" >
  </a>
</div>
<ng-container *ngTemplateOutlet="userData"></ng-container>
<ng-container *ngTemplateOutlet="linksList"></ng-container>

<ng-template #linksList>
  <div class="navContainer" [ngClass]="{'navContainerSmall': mainLink,'navContainer_dark': darkmode}">
    <ul class="nav" *ngIf="links">
      <li *ngFor="let link of links"  >
        <ng-container
          [ngTemplateOutlet]="link.nested ? expandableLinkTemplate : linkTemplate"
          [ngTemplateOutletContext]="{ link: link }"
        ></ng-container>
      </li>
    </ul>
  </div>
</ng-template>

<ng-template #userData>
   <mat-accordion id="user" class="home365-accordion-height home365-accordion no-inner-padding">
        <mat-expansion-panel appHome365AccordionArrow (opened)="mainLink = !mainLink" (closed)="mainLink = !mainLink">
          <mat-expansion-panel-header appHome365AccordionArrowHeader>
            <div id="user-cont" class="flex center-vr">
              <ng-container *ngIf="userDisplayDetails">
                <div class="circle-name-m user-img" [ngClass]="{'user_img_dark': darkmode}">
                  {{ getShortName(userDisplayDetails?.fullName) }}
                </div>
                <span id="user-name" class="leave" [@leave]="mini ? 'out' : 'in'" [ngClass]="{'leave_dark': darkmode}" >{{userDisplayDetails?.fullName}}</span>
              </ng-container>
              <ng-template #noUserDetailes>
                <img appHome365DefaultProfilePhoto alt="profile img" class="profile-photo" />
              </ng-template>
              <div  class="flex">
                <i class="fa-light fa-chevron-down" [ngClass]="{'fa-flip-vertical': mainLink, 'icon_dark': darkmode}"></i>
                <!-- <i class="material-icons arrow">arrow_drop_down</i> -->
              </div>
            </div>
          </mat-expansion-panel-header>
          <div
            *ngIf="canEditUser"
            routerLink="/pages/user"
            class="pointer"
            [ngClass]="darkmode ? 'admin-nav-link-dark' : 'admin-nav-link'"
            (click)="editUser()"
          >
            <span class="sidebar-mini">
              <i class="fa-light fa-user" [ngClass]="{'leave_dark': darkmode}"></i>
            </span>
            <span class="sidebar-normal leave" [ngClass]="{'leave_dark': darkmode}">{{'SIDENAV.EDIT_PROFILE' | translate}}</span>
          </div>
          <div class="pointer" [ngClass]="darkmode ? 'admin-nav-link-dark': 'admin-nav-link'" (click)="logOut()">
            <span class="sidebar-mini"><i class="fa-light fa-arrow-right-to-bracket" [ngClass]="{'icon_dark': darkmode}"></i></span>
            <span class="sidebar-normal leave" [ngClass]="{'leave_dark': darkmode}">{{'SIDENAV.LOG_OUT' | translate}}</span>
          </div>
        </mat-expansion-panel>
      </mat-accordion>
</ng-template>


<ng-template #expandableLinkTemplate let-linkGroup="link">
  <mat-accordion class="home365-accordion-height home365-accordion no-inner-padding no-border">
    <mat-expansion-panel [expanded]="linkGroup.expended" hideToggle appHome365AccordionArrow (opened)="linkGroup.open = !linkGroup.open" (closed)="linkGroup.open = !linkGroup.open">
      <mat-expansion-panel-header appHome365AccordionArrowHeader>
        <div class="flex center-vr width-100p admin-expand-link" >
          <!-- <i class="material-icons sidebar-icon">{{ linkGroup.icon }}</i> -->
          <i class="fa-light" [ngClass]="linkGroup.icon" [ngStyle]="{'color': darkmode ? '#fff' : ''}"></i>
          <p class="leave" [@leave]="mini ? 'out' : 'in'" [ngClass]="{'leave_dark': darkmode}" >{{ linkGroup.name }}</p>
          <ng-container
            [ngTemplateOutlet]="linkGroup.template"
            [ngTemplateOutletContext]="{ $implicit: linkGroup.templateContext }"
          ></ng-container>
          <span class="spaccer"></span>
          <div  class="flex" [@leave]="mini ? 'out' : 'in'">
            <i class="fa-light fa-chevron-down" [ngClass]="{'fa-flip-vertical': linkGroup.open,'icon_dark': darkmode}" ></i>
            <!-- <i class="material-icons arrow">arrow_drop_down</i> -->
          </div>
        </div>
      </mat-expansion-panel-header>
      <ng-container *ngFor="let link of linkGroup.nested">
        <ng-container [ngTemplateOutlet]="linkTemplate" [ngTemplateOutletContext]="{ link: link }"></ng-container>
      </ng-container>
    </mat-expansion-panel>
  </mat-accordion>
</ng-template>

<ng-template #linkTemplate let-link="link">
  <a
    [routerLinkActive]="link.hasUrl ? darkmode ?  'active_dark' : 'active' : ''"
    [routerLink]="link.url"
    class=" flex center-v {{link.style}}"
    [ngClass]="darkmode ? 'admin-nav-link-dark': 'admin-nav-link'"
  >
    <ng-container [ngTemplateOutlet]="link.icon ? icon : letterIcon" [ngTemplateOutletContext]="link"></ng-container>
    <p class="leave" [ngClass]="{'leave_dark': darkmode}" [@leave]="mini ? 'out' : 'in'">{{ link.name }}</p>
    <ng-container
      [ngTemplateOutlet]="link.template"
      [ngTemplateOutletContext]="{ $implicit: link.templateContext }"
    ></ng-container>
  </a>
</ng-template>

<ng-template #letterIcon let-letter="letter">
  <span class="sidebar-mini letter" [ngClass]="{'letter_dark': darkmode}">{{ letter }}</span>
</ng-template>
<ng-template #icon let-icon="icon">
  <i class="fa-light" [ngClass]="icon" [ngStyle]="{'color': darkmode ? '#fff' : ''}" ></i>
  <!-- <i class="material-icons sidebar-icon">{{ icon }}</i> -->
</ng-template>


<ng-template #notesBubble let-notificationData>
  <div class="countMessages" *ngIf="notificationData.count>0">{{notificationData.count}}</div>
</ng-template>